import { useState } from "react";
import html2canvas from "html2canvas";

function useShareCard() {
  const [showShareModal, setShowShareModal] = useState(false);

  const handleShare = () => {
    setShowShareModal(true);
  };

  const handleDownloadImage = async () => {
    try {
      const element = document.getElementById("share-card");
      if (!element) {
        console.error("Share card element not found");
        return;
      }

      const canvas = await html2canvas(element, {
        backgroundColor: null, // Transparent background
        scale: 2, // Higher resolution
        useCORS: true,
        allowTaint: true,
        width: 400,
        height: element.offsetHeight,
      });

      // Create download link
      const link = document.createElement("a");
      link.download = `scorecard-${new Date().toISOString().split("T")[0]}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (error) {
      console.error("Error generating image:", error);
      alert(
        "Sorry, there was an error generating the image. Please try again."
      );
    }
  };

  return {
    showShareModal,
    setShowShareModal,
    handleShare,
    handleDownloadImage,
  };
}

export default useShareCard;
